import React from 'react';
import '../App.css';
import Connect from '../articleComponents/connect';
import { motion } from 'framer-motion';
import DBH from '../pictures/dbh.jpg';
import SocialMedia from '../articleComponents/SocialMedia';
import dbh from '../pictures/dbh.jpg';
import MetaTags from './MetaTags';


function About() {
  return (
    <motion.div id="body"
initial={{ opacity: 0 }}
animate={{opacity: 1 }}
exit={{ opacity: 0}}
transition={{duration: .4}}
>
<MetaTags title="About David Ben Horin" desc="David Ben Horin is the developer for Highway 60. A marketer for 10 years, he decided to see what the other side of his profession is up to by coding this app." 
URL="https://highway-60.web.app/about" imageURL={dbh} />

      <br />
      <h1 id="test">About David Ben Horin</h1>
      <img src={DBH} style={{width: '15%', height: '30%', marginLeft: '42.5%', marginTop: '1.5%', marginBottom: '1.5%'}} alt="David Ben Horin"/>

      <h2>Portfolio of Favorite Content</h2>
      
      <ul>
    <a href="https://ravendb.net/articles/ravendb-wants-to-be-the-most-boring-database-ever" target="_blank" rel="noreferrer">
      <li>The Database that will Transform the Roaring 20s into the Boring 20s</li>
      </a>

<a href="https://www.youtube.com/watch?v=M574iIvLFDo " target="_blank" rel="noreferrer">
  <li>Time is Money and We Save You Both (Video Infomercial)</li>
  </a>

  <a href="https://ravendb.net/whitepapers/mongodb-ravendb-best-nosql-open-source-document-database" target="_blank" rel="noreferrer">
  <li>RavenDB vs MongoDB: A NoSQL Database Comparison (White Paper)</li>
  </a>

  <a href="https://www.breslev.co.il/articles/israel_and_society/israel_and_aliyah/yuppie_zionism.aspx?id=28058&language=english" target="_blank" rel="noreferrer">
  <li>Yuppie Zionism</li>
  </a>

  </ul>
  <br />

  <h2>Work History</h2>
  <a href="https://drive.google.com/file/d/1LD9zIEU-1HeJBoEKjIGH-FxGrpJrf6V_/view?usp=sharing" target="_blank">Resume of David Ben Horin</a>
  <br /><br />


  <SocialMedia url="https://highway-60.firebaseapp.com/about" title="About David Ben Horin" hashtag="#marketing" hashtagArray={["marketing", "writing"]} via="TheHighway60" desc="David Ben Horin is the developer and writer for Highway 60." />
<Connect />
{/* <img src={process.env.PUBLIC_URL + "/images/goForIt.jpg"} width="100px" style={{alignItems: "center"}} />  */}
  </motion.div>

  );
}


export default About;

